import { COPY } from "../constants";

export const getLanguageName = (langCode: string, defaultLang: string): string => {
  try {
    const [lang, region] = langCode.split('-');
    const languageName = new Intl.DisplayNames([langCode], { type: 'language' }).of(lang);
    const regionName = region
      ? new Intl.DisplayNames([langCode], { type: 'region' }).of(region)
      : null;
    const displayName = regionName
      ? `${languageName} (${regionName})`
      : languageName ?? langCode;
    const isDefault = langCode === defaultLang;
    return isDefault ? `${displayName} ${COPY.DEFAULT}` : displayName;
  } catch {
    return langCode;
  }
};

export const getRegionCode = (langCode: string): string | undefined => {
  const region = langCode.split('-')[1];
  return region ? region.toUpperCase() : undefined;
};